<template>
    <div>
        <div class="card border-primary mb-3">
            <div class="card-body">
                <!--{{model}}-->
                <kendo-datasource ref="staticregistersDatasource"
                                  :transport="staticregistersTransportSettings"
                                  :server-filtering="false"
                                  :server-paging="false"
                                  :schema-model-id="'registerId'"
                                  :schema-model-fields="schemaModelFields"
                                  :error="dataSourceError"
                                  :requestEnd="datasorceRequestEnd"
                                  :typeof="'odata-v4'">
                </kendo-datasource>

                <kendo-datasource ref="staticregistersDisplayMembersDatasource"
                                  :transport="staticregistersDisplatMembersTransportSettings"
                                  :server-filtering="false"
                                  :server-paging="false"
                                  :schema-model-id="'id'"
                                  :schema-model-fields="schemaModelFields"
                                  :error="dataSourceError"
                                  :requestEnd="datasorceRequestEnd"
                                  :typeof="'odata-v4'">
                </kendo-datasource>


                <div class="row">
                    <div class="form-group col-12">
                        <label class="font-weight-bold">{{$t('registers.staticRegistersForDropdown.gridHeaders.staticRegisterName')}}</label>
                        <kendo-dropdownlist v-model="model.registerId"
                                            :data-source-ref="'staticregistersDatasource'"
                                            :data-text-field="'text'"
                                            :data-value-field="'registerId'"
                                            :clear-button="true"
                                            :filter="'contains'"
                                            :optionLabel="$t('choose')"
                                            :name="'registerName' + _uid"
                                            :id="'registerName' + _uid"
                                            v-validate="'required'"
                                            :data-vv-as="$t('registers.staticRegistersForDropdown.gridHeaders.staticRegisterName')"
                                            :height="500"
                                            style="width:100%">
                        </kendo-dropdownlist>
                        <span class="text-danger col-12" v-if="errors.has('registerName' + _uid)">{{ errors.first('registerName' + _uid) }}</span>
                    </div>
                </div>

                <div class="row">
                    <div class="form-group col-12">
                        <label class="font-weight-bold">{{$t('registers.staticRegistersForDropdown.gridHeaders.displayMember')}}</label>
                        <kendo-dropdownlist v-model="model.displayMember"
                                            :data-source-ref="'staticregistersDisplayMembersDatasource'"
                                            :data-text-field="'text'"
                                            :data-value-field="'text'"
                                            :clear-button="true"
                                            :auto-bind="false"
                                            :cascade-from="'registerName' + _uid"
                                            :cascade-from-parent-field="'registerId'"
                                            :cascade-from-field="'parentId'"
                                            :filter="'contains'"
                                            :name="'displayMember' + _uid"
                                            :id="'displayMember' + _uid"
                                            v-validate="'required'"
                                            :data-vv-as="$t('registers.staticRegistersForDropdown.gridHeaders.displayMember')"
                                            :optionLabel="$t('choose')"
                                            :height="500"
                                            style="width:100%">
                        </kendo-dropdownlist>
                        <span class="text-danger col-12" v-if="errors.has('displayMember' + _uid)">{{ errors.first('displayMember' + _uid) }}</span>

                    </div>
                </div>

                <div class="row">
                    <div class="form-group col-12">
                        <label class="font-weight-bold" :for="'description' + _uid">{{ $t('registers.staticRegistersForDropdown.gridHeaders.description') }}</label>
                        <input type="text"
                               class="form-control"
                               v-model="model.description"
                               :id="'description' + _uid"
                               :readonly="false" />
                    </div>
                </div>

                <div class="row">
                    <div class="form-group col-6 mt-3">
                        <vs-checkbox v-model="model.deactivated"
                                     :name="'deactivated' + _uid"
                                     :id="'deactivated' + _uid"
                                     style="justify-content: flex-start !important">
                            {{ $t('registers.staticRegistersForDropdown.gridHeaders.deactivated') }}
                        </vs-checkbox>
                    </div>
                    <div class="form-group col-6 mt-3">
                        <vs-checkbox v-model="model.allowAnonymousAccesss"
                                     :name="'allowAnonymousAccesss' + _uid"
                                     :id="'allowAnonymousAccesss' + _uid"
                                     style="justify-content: flex-start !important">
                            {{ $t('registers.staticRegistersForDropdown.gridHeaders.allowAnonymousAccesss') }}
                        </vs-checkbox>
                    </div>
                </div>
            </div>

            <div class="card-footer">
                <div class="text-right mt-3">
                    <div class="btn-group" role="group" aria-label="Registers edit buttons">
                        <button type="button" class="btn btn-success" @click.stop="onSave"><i class="fas fa-save mr-2"></i>{{ $t('buttons.save.btnText')}}</button>
                        <button type="button" class="btn btn-danger" @click.stop="onCancel"><i class="fas fa-ban mr-2"></i>{{ $t('buttons.cancel')}}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { StaticRegistersForDropdown } from '@/models/models';
    import staticRegisterService from '@/services/staticRegister.service';

    export default {
        inject: ['$validator'],
        props: {
            value: {
                type: StaticRegistersForDropdown,
                required: false
            },
            create: {
                type: Boolean,
                default: false
            },
        },
        components: {

        },
        data() {
            return {
                model: this.value,
                staticregistersTransportSettings: {
                    read: {
                        url: this.$store.getters.baseUrl + `/api/dynamicregistersadministration/getRegistersSource`,
                        beforeSend: this.beforeSend
                    },
                    parameterMap: this.odata4ParameterMap
                },
                staticregistersDisplatMembersTransportSettings: {
                    read: {
                        url: this.$store.getters.baseUrl + `/api/dynamicregistersadministration/getRegisterMembersSource`,
                        beforeSend: this.beforeSend
                    },
                    parameterMap: this.odata4ParameterMap
                },
                schemaModelFields: {
                    id: { name: 'id', type: 'number', editable: false, nullable: true, visible: true },
                    registerId: { name: 'registerId', type: 'number', editable: false, nullable: true, visible: true },
                    text: { name: 'text', type: 'string', editable: false, nullable: true, visible: true },
                    textEn: { name: 'textEn', type: 'string', editable: false, nullable: true, visible: true },
                    parentId: { name: 'parentId', type: 'number', editable: false, nullable: true, visible: true },
                    parentName: { name: 'parentName', type: 'string', editable: false, nullable: true, visible: true },
                },


            }
        },
        methods: {
            odata4ParameterMap: function (options, operation) {
                if (operation !== 'read' && options.models) {
                    return { models: kendo.stringify(options.models) }
                } else {
                    const newOptions = kendo.data.transports["odata-v4"].parameterMap(options, operation);
                    return newOptions;
                }
            },
            beforeSend: function (req) {
                if (this.token) {
                    req.setRequestHeader('Authorization', 'Bearer ' + this.token);
                }
            },
            dataSourceError(e) {
                this.$vs.notify({
                    title: this.$t('notifications.error'),
                    text: this.$helpers.kendoDataSourceErrorText(e),
                    color: 'danger',
                    time: this.$store.getters.notificationDuration,
                });
            },
            datasorceRequestEnd(e) {
                if (e.type === "read" && e.response) {
                    // 	console.log(e.response[0]);
                    // alert(e.respondashboard-ctrlse[0].TaskID);
                }
            },
            onCancel() {
                this.$emit("cancel");
            },
            onSave() {
                this.$validator.validateAll().then(result => {
                    if (result) {
                        this.doSave();
                    }
                });
            },
            doSave() {
                if (this.create && this.isNew) {
                    this.createEntity();
                } else {
                    this.updateEntity();
                }
            },
            createEntity() {
                staticRegisterService
                    .create(this.model)
                    .then(response => {
                        let resultModel = response.data.model;

                        this.$vs.notify({
                            title: this.$t('request.response.status.' + this.$helpers.responseStatusCode(response)),
                            text: this.$helpers.responseMessage(response),
                            color: 'success',
                            time: this.$store.getters.notificationDuration
                        });

                        this.$emit("save", resultModel);
                    })
                    .catch(error => {
                        this.$vs.notify({
                            title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                            text: this.$helpers.errorText(error),
                            color: this.$helpers.errorColor(error),
                            time: this.$store.getters.notificationDuration
                        })
                    });
            },
            updateEntity() {
                staticRegisterService
                    .update(this.model)
                    .then(response => {
                        this.$vs.notify({
                            title: this.$t('request.response.status.' + this.$helpers.responseStatusCode(response)),
                            text: this.$helpers.responseMessage(response),
                            color: 'success',
                            time: this.$store.getters.notificationDuration
                        });

                        this.$emit("save", this.model);
                    })
                    .catch(error => {
                        this.$vs.notify({
                            title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                            text: this.$helpers.errorText(error),
                            color: this.$helpers.errorColor(error),
                            time: this.$store.getters.notificationDuration
                        })
                    });
            }

        },
        computed: {
            token: function () {
                return this.$store.getters.authToken;
            },
            isEnVersion() {
                return this.$store.getters.currentCulture === Culture.EN;
            },
            isNew() {
                let id = Number(this.model.id);
                return isNaN(id) || id <= 0;
            }
        },
        mounted() {

        },
        watch: {
            value: function (val) {
                if (val) {
                    this.model = new StaticRegistersForDropdown(this.value);
                }
            }
        }
    }
</script>

<style scoped>
    input[readonly] {
        background-color: whitesmoke;
    }

    textarea[readonly] {
        background-color: whitesmoke;
    }
</style>
